/** @module components/product-feed-count */
import baustein from "baustein";

/**
 * Simple component, waits to be told to display a message and then displays it
 * @alias module:components/product-feed-count
 * @extends module:baustein
 */
export default baustein.register(
    "product-feed-count",
    /** @lends module:components/product-feed-layout.prototype */
    {
        updateMessage(message) {
            this.el.textContent = message;
        },
    }
);
